module.exports = __webpack_public_path__ + "img/4.9447ed96.png";